import {
  InvoiceCreationEnum,
  InvoiceItemTypeEnum,
  InvoiceStatusEnum,
  InvoiceVoidReasonCodeEnum,
} from '@monetize/types/app';
import { objectToSelectOptions } from '../utils/misc';

export const InvoiceStatusEnumDisplay: {
  [key in InvoiceStatusEnum]: string;
} = {
  DRAFT: 'Draft',
  UNPAID: 'Unpaid',
  PAID: 'Paid',
  REVERSED: 'Reversed',
  VOID: 'Void',
};

export const INVOICE_VOID_REASON_CODE_DISPLAY: {
  [key in InvoiceVoidReasonCodeEnum]: string;
} = {
  GENERATED_IN_ERROR: 'Generated in Error',
  DUPLICATE_INVOICE: 'Duplicate Invoice',
  INCORRECT_AMOUNT: 'Incorrect Amount',
  INCORRECT_TAX: 'Incorrect Tax',
  MIGRATION_DATA_CORRECTION: 'Migration Data Correction',
  OTHER: 'Other',
};

export const INVOICE_VOID_REASON_CODE_OPTIONS = objectToSelectOptions(
  INVOICE_VOID_REASON_CODE_DISPLAY,
);

export const getInvoiceStatusStyle = (status?: InvoiceStatusEnum) => {
  switch (status) {
    case InvoiceStatusEnum.PAID:
      return { color: 'tGreen.mDarkShade', bg: 'tGreen.light' };
    default:
      return { color: 'tGray.darkGrayPurple', bg: 'transparent' };
  }
};

export const InvoiceItemTypeEnumDisplay: {
  [key in InvoiceItemTypeEnum]: string;
} = {
  SUBSCRIPTION: 'Subscription',
  ONETIME: 'Onetime',
  USAGE: 'Usage',
};

export const CHANGE_CONTACT_STATUSES = new Set([
  InvoiceStatusEnum.UNPAID,
  InvoiceStatusEnum.DRAFT,
]);

export const EMAIL_STATUSES = new Set([
  InvoiceStatusEnum.PAID,
  InvoiceStatusEnum.REVERSED,
]);

export const REVENUE_SCHEDULE_STATUSES = new Set([
  InvoiceStatusEnum.PAID,
  InvoiceStatusEnum.UNPAID,
]);

export const INVOICE_EMAIL_STATUSES = new Set([
  InvoiceStatusEnum.UNPAID,
  InvoiceStatusEnum.PAID,
]);

export const TAX_ERROR_CAN_RESOLVE_STATUSES = new Set([
  InvoiceStatusEnum.UNPAID,
  InvoiceStatusEnum.DRAFT,
]);

export const DEFAULT_INVOICE_SETTINGS = {
  invoiceTemplateConfig: {
    showUsageWithoutEvents: true,
    showOffering: true,
    showPpu: false,
  },
  invoiceEmailingConfig: {
    automatic: false,
  },
  invoiceAutomation: {
    invoiceCreation: InvoiceCreationEnum.AUTOMATIC,
    invoiceDelay: 0,
  },
};
